import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgVolumeLevel0 = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8328 10.6335L12.8336 17.7512C12.8336 18.7813 11.5486 19.3655 10.6677 18.7463L7.20265 16.2637L12.8328 10.6335ZM13.6867 5.74407C13.9942 5.74407 14.2833 5.86491 14.5009 6.08242C14.95 6.5316 14.95 7.26245 14.5009 7.71163L5.29559 16.9177C5.07725 17.1352 4.78808 17.2552 4.48057 17.2552C4.17306 17.2552 3.88389 17.1352 3.66555 16.9177C3.21637 16.4685 3.21637 15.7377 3.66555 15.2885L12.8716 6.08242C13.09 5.86491 13.3792 5.74407 13.6867 5.74407ZM12.785 4.91673L2.6702 15.0313C2.28243 14.8552 2.00167 14.4843 2.00167 14.0428L2 8.9585C2 8.37515 2.51335 7.8593 3.17503 7.8593H5.6351L10.6661 4.25336C11.4472 3.70504 12.5461 4.10165 12.785 4.91673Z", fill: props.fill }));
});
export default SvgVolumeLevel0;
